(function () {
  const STORAGE_KEY = "bh_feedback_tab_pos";
  const EMAIL_KEY = "bh_feedback_tab_email";
  const DRAG_THRESHOLD = 6;
  const MARGIN = 12;
  const SDK_SRC = "https://cdn.userloop.io/sdk-2/userloop.js";

  document.addEventListener("DOMContentLoaded", function () {
    const root = document.getElementById("bh-feedback-root");
    const tab = document.getElementById("bh-feedback-tab");
    const overlay = document.getElementById("bh-feedback-overlay");
    const mount = document.getElementById("userloop-feedback-mount");
    const status = document.getElementById("bh-feedback-status");

    if (!root || !tab || !overlay || !mount) return;

    const surveyId = (root.getAttribute("data-survey-id") || "").trim();
    const surveyUrl = (root.getAttribute("data-survey-url") || "").trim();
    const missingText = root.getAttribute("data-missing") || "Feedback is not configured.";
    const fallbackText = root.getAttribute("data-fallback") || "Open feedback form";
    const loadingText = root.getAttribute("data-loading") || "Loading…";
    const locale = (root.getAttribute("data-locale") || "en").trim() || "en";
    const SURVEY_I18N = {
      fr: {
        button_text: "Soumettre",
        thankyou_heading: "Merci",
        thankyou_subheading: "Vos commentaires nous aident à nous améliorer",
        question: "Quelle est la seule chose que nous pourrions améliorer sur ce site ?",
        placeholder_text: "Recherche, informations sur les produits ou tout ce qui vous a semblé incorrect…",
        skip_text: "Passer",
        email_label: "E-mail (facultatif)",
        restart: "Recommencer"
      },
      es: {
        button_text: "Enviar",
        thankyou_heading: "Gracias",
        thankyou_subheading: "Tus comentarios nos ayudan a mejorar",
        question: "¿Qué es algo que podríamos mejorar en este sitio?",
        placeholder_text: "Búsqueda, información del producto o cualquier cosa que no encajara…",
        skip_text: "Omitir",
        email_label: "Correo (opcional)",
        restart: "Reiniciar encuesta"
      }
    };
    const localeCopy = SURVEY_I18N[locale] || null;

    const customerId = (root.getAttribute("data-customer-id") || "").trim();
    const customerEmail = (root.getAttribute("data-customer-email") || "").trim();

    function readSavedEmail() {
      try {
        return (sessionStorage.getItem(EMAIL_KEY) || "").trim();
      } catch (err) {
        return "";
      }
    }

    function persistEmail(value) {
      const email = (value || "").trim();
      if (!email || email.indexOf("@") === -1) return;
      try {
        sessionStorage.setItem(EMAIL_KEY, email);
      } catch (err) {
        /* private mode */
      }
      sdkContext.customer.email = email;
      sdkConfig.email_collection = false;
    }

    function captureEmailFromDom() {
      const input = mount.querySelector("#email_collection_input");
      if (input) persistEmail(input.value);
    }

    function knownEmail() {
      return customerEmail || readSavedEmail();
    }

    const sdkConfig = {
      email_collection: !knownEmail(),
      expanded_mode: true,
      allow_restart: true,
      surface: "feedback-tab",
      language: locale,
      locale: locale,
      lang: locale
    };
    const sdkContext = {
      customer: {},
      transaction: {}
    };
    if (customerId) sdkContext.customer.id = customerId;
    if (knownEmail()) sdkContext.customer.email = knownEmail();

    let dragMoved = false;
    let dragging = false;
    let dragStartY = 0;
    let startTop = 0;
    let sdkLoading = false;
    let surveyInstance = null;
    let surveyInited = false;
    let surveyBusy = false;
    let lastActive = null;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function applyPosition(top) {
      const rect = tab.getBoundingClientRect();
      const height = rect.height || 120;

      top = clamp(top, MARGIN, window.innerHeight - height - MARGIN);

      tab.classList.add("bh-feedback-tab--moved");
      tab.style.left = "auto";
      tab.style.right = "0";
      tab.style.bottom = "auto";
      tab.style.top = top + "px";
      tab.style.transform = "none";

      return { top: top };
    }

    function persistPosition() {
      try {
        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ top: tab.getBoundingClientRect().top })
        );
      } catch (err) {
        /* private mode */
      }
    }

    function restorePosition() {
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (err) {
        /* ignore */
      }
      tab.classList.remove("bh-feedback-tab--moved");
      tab.style.top = "";
      tab.style.bottom = "";
      tab.style.left = "";
      tab.style.right = "";
      tab.style.transform = "";
    }

    function onPointerDown(e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;

      dragging = true;
      dragMoved = false;
      dragStartY = e.clientY;
      startTop = tab.getBoundingClientRect().top;

      tab.classList.add("bh-feedback-tab--dragging");
      tab.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
      if (!dragging) return;

      const dy = e.clientY - dragStartY;

      if (Math.abs(dy) > DRAG_THRESHOLD) {
        dragMoved = true;
      }

      applyPosition(startTop + dy);
    }

    function onPointerUp(e) {
      if (!dragging) return;

      dragging = false;
      tab.classList.remove("bh-feedback-tab--dragging");

      if (tab.hasPointerCapture(e.pointerId)) {
        tab.releasePointerCapture(e.pointerId);
      }

      if (dragMoved) {
        applyPosition(tab.getBoundingClientRect().top);
        persistPosition();
      }
    }

    function isOpen() {
      return overlay.classList.contains("is-open");
    }

    function showStatus(text) {
      status.hidden = false;
      status.textContent = text;
    }

    function hideStatus() {
      status.hidden = true;
      status.textContent = "";
    }

    function showFallback(message) {
      const safeMsg = message || missingText;
      if (surveyUrl) {
        const a = document.createElement("a");
        a.href = surveyUrl;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.textContent = fallbackText;
        status.hidden = false;
        status.textContent = "";
        status.appendChild(document.createTextNode(safeMsg + " "));
        status.appendChild(a);
        return;
      }
      showStatus(safeMsg);
    }

    function mountHasSurvey() {
      return mount.childElementCount > 0 && mount.textContent.trim().length > 0;
    }

    function loadSdk() {
      if (typeof window.UserLoop === "function") {
        return Promise.resolve();
      }
      if (sdkLoading) {
        return new Promise(function (resolve, reject) {
          const start = Date.now();
          const timer = setInterval(function () {
            if (typeof window.UserLoop === "function") {
              clearInterval(timer);
              resolve();
            } else if (Date.now() - start > 15000) {
              clearInterval(timer);
              reject(new Error("timeout"));
            }
          }, 50);
        });
      }

      sdkLoading = true;
      return new Promise(function (resolve, reject) {
        const script = document.createElement("script");
        script.src = SDK_SRC;
        script.async = true;
        script.onload = function () {
          resolve();
        };
        script.onerror = function () {
          sdkLoading = false;
          reject(new Error("script"));
        };
        document.head.appendChild(script);
      });
    }

    function patchSurveyPayload(data) {
      if (!localeCopy || !data) return data;
      data.button_text = localeCopy.button_text;
      data.thankyou_heading = localeCopy.thankyou_heading;
      data.thankyou_subheading = localeCopy.thankyou_subheading;
      if (data.questions && data.questions[0]) {
        data.questions[0].question = localeCopy.question;
        data.questions[0].placeholder_text = localeCopy.placeholder_text;
        data.questions[0].skip_text = localeCopy.skip_text;
      }
      return data;
    }

    function installSurveyFetchPatch() {
      if (!localeCopy || window.__bhFeedbackFetchPatched) return;
      window.__bhFeedbackFetchPatched = true;
      const originalFetch = window.fetch;
      window.fetch = function (input) {
        const url = typeof input === "string" ? input : (input && input.url) || "";
        const request = originalFetch.apply(this, arguments);
        if (url.indexOf("/api/1.1/wf/get-survey") === -1) return request;
        return request.then(function (res) {
          if (!res.ok) return res;
          return res.text().then(function (body) {
            try {
              return new Response(JSON.stringify(patchSurveyPayload(JSON.parse(body))), {
                status: res.status,
                statusText: res.statusText,
                headers: { "Content-Type": "application/json" }
              });
            } catch (err) {
              return new Response(body, { status: res.status, headers: res.headers });
            }
          });
        });
      };
    }

    function optionalEmailLabel() {
      return (localeCopy && localeCopy.email_label) || "Email (optional)";
    }

    function isEmailCollectionLabel(text) {
      return /enter your email|e-mail \(facultatif\)|e-mail pour continuer|correo \(opcional\)|correo para continuar|email \(optional\)/i.test(
        text || ""
      );
    }

    function tabEmailField() {
      return mount.querySelector(".email-collection-container #email_collection_input");
    }

    function applyEmailOptional() {
      const container = mount.querySelector(".email-collection-container");
      if (!container) return;

      const input = container.querySelector("#email_collection_input");
      if (input) {
        input.required = false;
        input.removeAttribute("required");
        input.setAttribute("aria-required", "false");
      }

      const labelText = optionalEmailLabel();
      container.querySelectorAll("label").forEach(function (el) {
        if (!isEmailCollectionLabel(el.textContent || "")) return;
        if (el.textContent !== labelText) el.textContent = labelText;
      });

      patchEmailOptionalSubmit();
    }

    function patchEmailOptionalSubmit() {
      const cfg = window.UserLoopConfig;
      if (!cfg || cfg._bhOptionalEmailPatched) return;
      if (typeof cfg.submitExpandedModeResponses !== "function") return;

      cfg._bhOptionalEmailPatched = true;
      const original = cfg.submitExpandedModeResponses;
      cfg.submitExpandedModeResponses = async function () {
        const emailInput = tabEmailField();
        if (cfg.surface !== "feedback-tab" || !emailInput) {
          return original.apply(this, arguments);
        }

        const email = (emailInput.value || "").trim();
        const previous = cfg.needsEmailCollection;
        if (!email) cfg.needsEmailCollection = false;

        try {
          const result = await original.apply(this, arguments);
          if (result === false && !email && previous) {
            cfg.needsEmailCollection = true;
          }
          return result;
        } catch (err) {
          if (!email && previous) cfg.needsEmailCollection = true;
          throw err;
        }
      };
    }

    function translateSdkChrome() {
      applyEmailOptional();
      if (!localeCopy) return;
      mount.querySelectorAll("button, a").forEach(function (el) {
        const text = (el.textContent || "").trim();
        if (/^restart survey$/i.test(text)) el.textContent = localeCopy.restart;
        if (/^skip$/i.test(text)) el.textContent = localeCopy.skip_text;
        if (/^submit$/i.test(text)) el.textContent = localeCopy.button_text;
      });
    }

    function createInstance() {
      return window.UserLoop(surveyId, mount, sdkConfig, sdkContext);
    }

    function initSurvey() {
      if (surveyInited || surveyBusy) return Promise.resolve();
      if (!surveyId) {
        mount.innerHTML = "";
        showFallback(missingText);
        return Promise.resolve();
      }

      surveyBusy = true;
      showStatus(loadingText);

      return loadSdk()
        .then(function () {
          if (typeof window.UserLoop !== "function") {
            throw new Error("missing");
          }
          surveyInstance = createInstance();
          const result = surveyInstance.init();
          return result && typeof result.then === "function" ? result : undefined;
        })
        .then(function () {
          surveyInited = true;
          hideStatus();
          if (typeof surveyInstance.mount === "function") {
            surveyInstance.mount();
          }
          translateSdkChrome();
        })
        .catch(function () {
          surveyInited = false;
          surveyInstance = null;
          showFallback(missingText);
        })
        .then(function () {
          surveyBusy = false;
        });
    }

    function remountSurvey() {
      captureEmailFromDom();
      const email = knownEmail();
      if (email) {
        sdkContext.customer.email = email;
        sdkConfig.email_collection = false;
      }
      surveyInited = false;
      surveyBusy = false;
      surveyInstance = null;
      mount.innerHTML = "";
      return initSurvey();
    }

    function refreshSurvey() {
      if (!surveyId) return Promise.resolve();

      if (surveyInstance && typeof surveyInstance.refresh === "function") {
        surveyBusy = true;
        showStatus(loadingText);
        return Promise.resolve(surveyInstance.refresh())
          .then(function () {
            if (typeof surveyInstance.mount === "function") {
              surveyInstance.mount();
            }
            hideStatus();
            translateSdkChrome();
            if (!mountHasSurvey()) return remountSurvey();
          })
          .catch(function () {
            return remountSurvey();
          })
          .then(function () {
            surveyBusy = false;
          });
      }

      return remountSurvey();
    }

    function openOverlay() {
      lastActive = document.activeElement;
      overlay.classList.add("is-open");
      overlay.setAttribute("aria-hidden", "false");
      overlay.removeAttribute("inert");
      tab.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";

      const ready = surveyInited
        ? mountHasSurvey()
          ? Promise.resolve()
          : refreshSurvey()
        : initSurvey();

      ready.then(function () {
        translateSdkChrome();
        const closeBtn = overlay.querySelector("[data-bh-feedback-dismiss].bh-feedback-overlay__close");
        if (closeBtn) closeBtn.focus();
      });
    }

    function closeOverlay() {
      overlay.classList.remove("is-open");
      overlay.setAttribute("aria-hidden", "true");
      overlay.setAttribute("inert", "");
      tab.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
      if (lastActive && typeof lastActive.focus === "function") {
        lastActive.focus();
      } else {
        tab.focus();
      }
    }

    tab.addEventListener("pointerdown", onPointerDown);
    tab.addEventListener("pointermove", onPointerMove);
    tab.addEventListener("pointerup", onPointerUp);
    tab.addEventListener("pointercancel", onPointerUp);

    tab.addEventListener("click", function () {
      if (dragMoved) {
        dragMoved = false;
        return;
      }
      if (isOpen()) {
        closeOverlay();
      } else {
        openOverlay();
      }
    });

    overlay.querySelectorAll("[data-bh-feedback-dismiss]").forEach(function (el) {
      el.addEventListener("click", closeOverlay);
    });

    function isRestartControl(el) {
      if (!el) return false;
      if (el.classList && el.classList.contains("userloop-restart-btn")) return true;
      const text = (el.textContent || "").toLowerCase();
      return /restart|recommencer|reiniciar/.test(text);
    }

    mount.addEventListener("input", function (e) {
      if (e.target && e.target.id === "email_collection_input") {
        persistEmail(e.target.value);
      }
    });

    mount.addEventListener(
      "click",
      function (e) {
        const el = e.target.closest("a, button");
        if (!el) return;
        if (el.id === "email_collection_input") return;
        captureEmailFromDom();
        if (!isRestartControl(el)) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }
        remountSurvey();
      },
      true
    );

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) {
        e.preventDefault();
        closeOverlay();
      }
    });

    window.addEventListener("resize", function () {
      if (!tab.classList.contains("bh-feedback-tab--moved")) return;
      applyPosition(tab.getBoundingClientRect().top);
      persistPosition();
    });

    restorePosition();
    overlay.setAttribute("lang", locale);
    mount.setAttribute("lang", locale);
    overlay.setAttribute("aria-hidden", "true");
    overlay.setAttribute("inert", "");
    installSurveyFetchPatch();
    if (window.MutationObserver) {
      new MutationObserver(function () {
        applyEmailOptional();
        if (localeCopy) translateSdkChrome();
      }).observe(mount, {
        childList: true,
        subtree: true
      });
    }
  });
})();
